export default __webpack_public_path__ + "static/media/imagesDesc.7cf99eb4.png";